module.exports = "/assets/5abce96d77466d4edd42029f0ee05738.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/X3.png
// module id = 3100
// module chunks = 0